/**
 * 프리렌더-안전 wall-clock 헬퍼.
 *
 * Next cacheComponents 프리렌더 스코프에서 인자 없는 `new Date()` / `Date.now()`는
 * "unstable value"로 차단된다. 로거·관측성은 에러 보고 경로에서 프리렌더 중에도
 * 호출되므로(onRequestError → reportError), 여기서 걸리면 원래 에러 대신 로거
 * 프레임이 Blocking Route로 보고되는 마스킹이 생긴다. `performance.now()`는
 * 프리렌더에서 허용되는 타이밍 API이고 timeOrigin과 합치면 wall-clock이 된다
 * (숫자 인자 Date 생성은 결정론 입력이라 허용).
 */

export function prerenderSafeNowMs(): number {
  return performance.timeOrigin + performance.now();
}

export function prerenderSafeNowIso(): string {
  return new Date(prerenderSafeNowMs()).toISOString();
}
